import React from 'react';
import { DocumentStatus } from '@alucio/aws-beacon-amplify/src/models';
import { DNABox, DNAButton, DNACard, DNAText, DNATextProps, Iffy, useTheme } from '@alucio/lux-ui';
import {
  DNACustomFieldChipList,
  DNADocumentStatusChip,
  DNADocumentThumbnail,
  RenderExcerpt,
  useCurrentPage,
} from 'src/components/DNA';
import { DocumentORM } from 'src/types/types';
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types';
import { CustomLabelDisplay } from '../default/CustomLabelDisplay';
import { useDocumentSearchV2Context } from 'src/hooks/useDocumentSearchV2';

const DNAFileDrawerDefaultRow: DNARowsComponent<
  DocumentORM
> = (props) => {
  const {
    ORM: documentORM,
    onPress,
    style,
    isSearch,
  } = props

  const theme = useTheme()
  const route = useCurrentPage({ exact: false })
  const isPublisherRoute = route?.configOptions?.modules?.includes('publisher')
  const isDocument = documentORM.type === 'DOCUMENT'
  const isDocumentWithUnpublishedVersion = isDocument &&
    documentORM.meta.hasUnpublishedVersion &&
    documentORM.model.status === DocumentStatus.PUBLISHED

  const { documentIdSnippetMap } = useDocumentSearchV2Context();

  const snippet = documentIdSnippetMap.get(documentORM.model.id);

  const showSnippet = snippet?.documentExcerpt && isSearch;

  const titleProps: DNATextProps = {
    b1: true,
    testID: 'folder-item-row-name',
    numberOfLines: 1,
  }

  const snippetProps: DNATextProps = {
    status: 'subtle',
    numberOfLines: 3,
    testID: 'drop-down-results-snippet',
  }

  return (
    <DNACard
      appearance="flat"
      interactive="pressable"
      onPress={() => { onPress?.(documentORM) }}
      style={[
        {
          paddingHorizontal: theme['row-padding-horizontal'],
          paddingVertical: theme['row-padding-vertical'],
          backgroundColor: 'transparent',
        },
        style,
      ]}
    >
      <DNABox alignY="center" spacing="between" childFill={0}>
        <DNABox alignY="center" spacing="lg" childFill={1}>
          <DNABox appearance="row">
            <DNADocumentThumbnail.Hover
              documentVersionORM={
                documentORM.relations.version.latestPublishedDocumentVersionORM ||
                documentORM.relations.version.latestDocumentVersionORM
              }
              width={isSearch ? 160 : 120}
              height={isSearch ? 90 : 68}
              showProcessing
            />
          </DNABox>
          {/* Title */}
          <DNABox
            spacing="sm"
            appearance="col"
            childFill
            style={{ paddingRight: 16 }}
          >
            {snippet?.title
              ? <RenderExcerpt
                  textProps={titleProps}
                  text={snippet.title.text}
              />
              : <DNAText {...titleProps} >
                {documentORM.relations.version.latestUsableDocumentVersionORM.model.title}</DNAText>}
            {showSnippet &&
            ( <RenderExcerpt
              pageNumber={snippet.pageNumber}
              textProps={snippetProps}
              text={snippet.documentExcerpt.text}
            />
            )}
            <DNABox alignY="center" spacing="sm" fill childFill={2}>
              <DNACustomFieldChipList
                documentVersionORM={documentORM.relations.version.latestUsableDocumentVersionORM}
              />
              <Iffy is={isPublisherRoute}>
                <DNADocumentStatusChip
                  documentStatus={documentORM.model.status}
                  isDraft={isDocumentWithUnpublishedVersion}
                />
              </Iffy>
              <DNABox fill>
                <CustomLabelDisplay documentORM={documentORM} />
              </DNABox>
            </DNABox>
          </DNABox>
        </DNABox>
        {/* Actions */}
        <DNABox spacing="sm" alignY="center">
          <DNAButton
            appearance="outline"
            status="primary"
            size="md"
            onPress={() => onPress?.(documentORM)}
            children="Add"
          />
        </DNABox>
      </DNABox>
    </DNACard>
  )
}

export default DNAFileDrawerDefaultRow
